import { render, staticRenderFns } from "./MenuPartnerIntegrations.vue?vue&type=template&id=19bdbe9c&scoped=true"
import script from "./MenuPartnerIntegrations.vue?vue&type=script&lang=js"
export * from "./MenuPartnerIntegrations.vue?vue&type=script&lang=js"
import style0 from "./MenuPartnerIntegrations.vue?vue&type=style&index=0&id=19bdbe9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bdbe9c",
  null
  
)

export default component.exports